import { useTranslation } from "react-i18next";
import type { Product } from "types";
import CrudEdit from "common/components/Crud/CrudEdit";
import { TableColumn } from "common/components/DataTable/DataTable";
import { CrudHeaderAction } from "common/components/Crud/components/CrudHeader";
import { CrudFilter } from "common/components/Crud/components/CrudFilters";
import CrudList from "common/components/Crud/CrudList";
import { useMemo } from "react";
import useRouter from "common/hooks/use-router";
import ProductForm from "./ProductForm";
import { ProductNameLabel } from "./productUtils";

function SidebarProductForm({ ...props }: any) {
  return <CrudEdit collectionName="products" Form={ProductForm} {...props} />;
}

function Products() {
  const { t } = useTranslation();
  const { navigate } = useRouter();

  const handleNavigate = (id: any) => {
    navigate(`/products/edit/${id}`);
  };

  const columns: TableColumn<Product>[] = useMemo(
    () => [
      {
        field: "image",
        header: t("products.image"),
        renderType: "image",
      },
      {
        field: "name",
        header: t("products.name"),
        sortable: true,
        customRender: (item: Product) => <ProductNameLabel product={item} />,
      },
      {
        field: "description",
        header: t("products.description"),
      },
    ],
    [t]
  );

  const actions: CrudHeaderAction[] = useMemo(() => {
    return [
      {
        title: t("common.new"),
        icon: "PlusCircleIconSolid",
        action: "openSidebar",
        type: "white",
        className: "flex flex-row-reverse",
      },
    ];
  }, [t]);

  const filters: CrudFilter[] = useMemo(() => {
    return [
      {
        name: "name$containsi",
        label: t("products.name"),
        renderType: "input",
        icon: "MagnifyingGlassIcon",
      },
    ];
  }, [t]);

  return (
    <CrudList
      collectionName="products"
      columns={columns}
      headerActions={actions}
      filters={filters}
      defaultSort="name:ASC"
      canDelete
      canEdit
      formMode="sidebar"
      SidebarFormComponent={SidebarProductForm}
      onNavigate={handleNavigate}
      actionsHeader=""
      className="pt-2 px-4"
    />
  );
}

export default Products;
